// 🔔
const Bell = ({ size=24, color="#3c3c43", ...props }) => (
    <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
    >
        <defs>
            {/* <!-- Rich gold gradient for the main bell body --> */}
            <linearGradient id="bellGold" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#FFE066" />
                <stop offset="40%" stopColor="#F5B041" />
                <stop offset="100%" stopColor="#C0392B" />
            </linearGradient>
            
            {/* <!-- Darker accent gradient for the clapper and top loop --> */}
            <linearGradient id="darkGold" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#D35400" />
                <stop offset="100%" stopColor="#A04000" />
            </linearGradient>
        </defs>

        {/* <!-- Top Loop/Handle --> */}
        <path d="M12 2A3 3 0 0 0 9 5v1h6V5a3 3 0 0 0 -3 -3z" fill="url(#darkGold)" />

        {/* <!-- Main Bell Body --> */}
        <path d="M12 6a6 6 0 0 0 -6 6v3.5L4 18h16l-2-2.5V12a6 6 0 0 0 -6 -6z" fill="url(#bellGold)" />

        {/* <!-- Bottom Rim/Flange --> */}
        <path d="M3 18h18v1.5a1.5 1.5 0 0 1 -1.5 1.5h-15A1.5 1.5 0 0 1 3 19.5z" fill="url(#darkGold)" />

        {/* <!-- Clapper/Clapper Ball (Bottom center) --> */}
        <path d="M10 21a2 2 0 0 0 4 0z" fill="url(#darkGold)" />
    </svg>
);

export default Bell;
